export const oneWalletHelperModule = (
    function () {
        const {
            getBonusGroupId = item => item.bonusData?.groupID || item.bonusData?.bonusRuleGroupId,
        } = {};

        return {
            getBonusGroupId
        }
    }
)();